import { useAppSelector } from "@/store/hooks";
import { checkAuth } from "@/utils/common";
import { useEffect } from "react";
import { Navigate, Outlet } from "react-router-dom";

interface PrivateRouteProps {
  fallbackPath: string;
}
export const PrivateRoute = ({ fallbackPath }: PrivateRouteProps) => {
  const isAuth = checkAuth();
  const { loggedUserData } = useAppSelector((state) => state.loginReducer);
  useEffect(() => {}, [loggedUserData]);
  if (!isAuth) {
    return <Navigate to={fallbackPath} />;
  } else return <Outlet />;
};
